/* unplugin-vue-components disabled */import { render } from "./yujipop.vue?vue&type=template&id=06baebe4&scoped=true"
import script from "./yujipop.vue?vue&type=script&lang=js"
export * from "./yujipop.vue?vue&type=script&lang=js"

import "./yujipop.vue?vue&type=style&index=0&id=06baebe4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06baebe4"]])

export default __exports__